<div class="label">
    <ng-content></ng-content>
</div>
